import { useCallback } from "react";

import useClient from "hooks/useClient";

const useFindParkingGuideByEstimateId = (): {
  findParkingGuide: (estimateId: string) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const findParkingGuide = useCallback(
    async (estimateId: string) => {
      const { data } = await client<Attachment, unknown>({
        method: "get",
        url: `/order/:orderId/estimate/parking-guide-pdf/${estimateId}`,
      });
      return data;
    },
    [client]
  );

  return { findParkingGuide };
};

export default useFindParkingGuideByEstimateId;
